import { createApiRequest } from '../common';

/**
 * Request body for /integrations/onboarding/scan-more.
 * Backend defaults all fields, so the frontend can post `{}` to extend the
 * default 12-month onboard by 3 more 30-day windows. Subsequent clicks pass
 * the previously-returned `scannedFromEpochSeconds` as the new
 * `untilEpochSeconds` to keep walking further back without overlap.
 */
export interface ScanMoreOnboardingRequest {
  channel?: 'email';
  additionalWindows?: number;
  untilEpochSeconds?: number;
}

export interface ScanMoreOnboardingResponse {
  workflowId: string | null;
  reason: string;
  scannedFromEpochSeconds: number | null;
  scannedToEpochSeconds: number | null;
}

export const scanMoreOnboardingApi = async (
  request: ScanMoreOnboardingRequest = {},
): Promise<ScanMoreOnboardingResponse> => {
  const apiRequest = createApiRequest<ScanMoreOnboardingResponse>(
    'post',
    '/integrations/onboarding/scan-more',
  );
  return apiRequest(request);
};
